import "./ListCourses.css";
import CurrentlyEnrolled from "./CurrentlyEnrolled.js";
import WantToTake from "./WantToTake.js";
import AlreadyTook from "./AlreadyTook.js";
import { withRouter } from "react-router";
import PropTypes from "prop-types";

function ListCourses(props) {
  // Prevent default behavior of form action by specifying route;
  // Effect: going to "/search" instead of "/search?" by clicking button
  function handleSubmit(event) {
    event.preventDefault();
    props.history.push("/search");
  }

  return (
    <div className="list-courses">
      <div className="list-courses-title">
        <h1>My Courses</h1>
      </div>
      <div className="list-courses-content">
        <div>
          <CurrentlyEnrolled
            courses={props.courses.filter(course => course.status === "enrolled")}
            updateCourse={props.updateCourse}
            removeCourse={props.removeCourse}
          />
          <WantToTake
            courses={props.courses.filter(course => course.status === "interested")}
            updateCourse={props.updateCourse}
            removeCourse={props.removeCourse}
          />
          <AlreadyTook
            courses={props.courses.filter(course => course.status === "taken")}
            updateCourse={props.updateCourse}
            removeCourse={props.removeCourse}
          />
        </div>
      </div>
      <div>
        <form action="/search" onSubmit={handleSubmit}>
          <button type="submit" className="open-search"/>
        </form>
      </div>
    </div>
  );
}

export default withRouter(ListCourses);

ListCourses.propTypes = {
  courses: PropTypes.arrayOf(
    PropTypes.shape({
      number: PropTypes.string,
      title: PropTypes.string,
      term: PropTypes.string,
      status: PropTypes.string,
      _id: PropTypes.string,
      color: PropTypes.string,
    })
  ),
  updateCourse: PropTypes.func.isRequired,
  removeCourse: PropTypes.func.isRequired,
}
